<div class="editor">
  <div class="flex justify-between items-center mb-2">
    <div class="text-base font-semibold text-gray-700">{{ title }}</div>
    <div class="flex gap-2">
      @if (showPromoteButton && !readonly && hasParadaIntermediaria()) {
        <button
          mat-stroked-button
          class="btn-tg-outline"
          (click)="promoveItinerario()"
          matTooltip="Salvar essas paradas como itinerário-template do tarifário"
        >
          <mat-icon>bookmark_add</mat-icon>
          Salvar paradas como itinerário do tarifário
        </button>
      }
      @if (!readonly) {
        <button mat-flat-button class="btn-tg" (click)="addParada()">
          <mat-icon>add</mat-icon>
          Adicionar parada
        </button>
      }
    </div>
  </div>

  @if (paradas.length === 0) {
    <div class="empty">
      <mat-icon>place</mat-icon>
      <span>Nenhuma parada cadastrada.</span>
    </div>
  } @else {
    <div cdkDropList class="paradas-list" (cdkDropListDropped)="drop($event)">
      @for (p of paradas; track trackByOrdem($index, p); let i = $index) {
        <div class="parada-row" cdkDrag [cdkDragDisabled]="readonly">
          @if (!readonly) {
            <button class="drag-handle" cdkDragHandle matTooltip="Arraste para reordenar">
              <mat-icon>drag_indicator</mat-icon>
            </button>
          }
          <div class="parada-ordem">{{ p.ordem }}</div>
          <div class="parada-info">
            @if (cityStateOnly) {
              <div class="parada-title">{{ paradaLine(p) }}</div>
            } @else {
              <div class="parada-title">
                {{ p.localParada || 'Sem descrição' }}
              </div>
              <div class="parada-sub">{{ paradaLine(p) }}</div>
              @if (isParadaIncompleta(p)) {
                <div class="flex items-center gap-1 text-amber-600 text-xs mt-1">
                  <mat-icon style="font-size: 16px; width: 16px; height: 16px"
                    >warning</mat-icon
                  >
                  <span>Preencha descrição, cidade e estado desta parada (clique em editar).</span>
                </div>
              }
            }
          </div>
          @if (!readonly) {
            <div class="parada-actions">
              <button mat-icon-button (click)="editParada(i)" matTooltip="Editar">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button (click)="removeParada(i)" matTooltip="Remover">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          }
        </div>
      }
    </div>
  }
</div>
